import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import logo from '@/assets/reactor.png'

function BioReactorPharmaNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={logo} alt="Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Bio Reactor</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default BioReactorPharmaNode
